import _ from 'underscore';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { Input } from '../../../../../lib/web/components/input';
import { ChildRef } from '../../../../../lib/web/components/child-ref';

@Component({
    selector: '.a-sign-languages-menu'
})

export class SignLanguagesMenuComponent extends ComponentBase<HTMLElement> {
    
    @Input('locales', { isJSON: true })
    private _locales: { id: number, code: string, name: string, signLanguageName: string }[] = null;

    @ChildRef('.a-sign-languages-menu__content-items')
    private _signLanguagesMenuListElement: HTMLUListElement = null;

    private _selectedVideo: string = null;

    public constructor(node: HTMLElement) {
        super(node);
    }

    private updateMenu(mediaId?: string): void {
        this._selectedVideo = mediaId == 'disabled' ? null : mediaId;
        this._signLanguagesMenuListElement.querySelectorAll('li').forEach(signLanguageElement => {
            signLanguageElement.classList.remove('a-sign-languages-menu__item--selected');
            if (signLanguageElement.dataset.id === mediaId) {
                signLanguageElement.classList.add('a-sign-languages-menu__item--selected');
            }
        });
    }

    public addSignLanguages(signLanguages: { locale: number, mediaId: string; }[], selectedVideo: string): void {
        this._selectedVideo = selectedVideo;
        this._signLanguagesMenuListElement.querySelectorAll('.a-sign-languages-menu__item').forEach(signLanguageElement => {
            this._signLanguagesMenuListElement.removeChild(signLanguageElement);
        });
        signLanguages.forEach((signLanguage, index, array) => {
            const element: HTMLLIElement = document.createElement('li');
            element.classList.add('a-sign-languages-menu__item');
            element.innerHTML = this.getLocale(signLanguage.locale);
            element.role = 'button';
            element.dataset.id = signLanguage.mediaId;                       
            element.addEventListener('click', () => {
                if (signLanguage.mediaId != this._selectedVideo) {
                    this.updateMenu(signLanguage.mediaId);
                    this.dispatchCustomEvent('sign-language-changed', signLanguage.mediaId);
                }
                this.hide();
            });

            element.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Enter') {
                    if (signLanguage.mediaId != this._selectedVideo) {
                        this.updateMenu(signLanguage.mediaId);
                        this.dispatchCustomEvent('sign-language-changed', signLanguage.mediaId);
                    }
                }
                this.hide();
            });
            this._signLanguagesMenuListElement.appendChild(element);
        });

        const disabledTextElement: HTMLLIElement = document.createElement('li');
        disabledTextElement.classList.add('a-sign-languages-menu__item');
        disabledTextElement.innerHTML = USER_LOCALE.disabled;
        disabledTextElement.role = 'button';
        disabledTextElement.dataset.id = 'disabled';        
        disabledTextElement.addEventListener('click', () => {
            if (this._selectedVideo) {
                this.updateMenu('disabled');
                this.dispatchCustomEvent('sign-language-changed');
            }
            this.hide();
        });
        disabledTextElement.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                if (this._selectedVideo) {
                    this.updateMenu('disabled');
                    this.dispatchCustomEvent('sign-language-changed');
                }
            }
            this.hide();
        });
        this._signLanguagesMenuListElement.appendChild(disabledTextElement);
        this.updateMenu(this._selectedVideo || 'disabled');
        this._signLanguagesMenuListElement.ariaSetSize = (signLanguages.length + 1).toString();
    }

    private getLocale(id: number): string {
        const name: string = ((this._locales || []).find(l => l.id == id) || {}).signLanguageName;
        return name || id.toString();
    }

    private show(): void {
        this.addClass('a-sign-languages-menu--show');
        this._signLanguagesMenuListElement.querySelectorAll('.a-sign-languages-menu__item').forEach(element => {
            (element as HTMLLIElement).tabIndex = 0;
        });
    }

    public hide(): void {
        this.removeClass('a-sign-languages-menu--show');
        this._signLanguagesMenuListElement.querySelectorAll('.a-sign-languages-menu__item').forEach(element => {
            (element as HTMLLIElement).tabIndex = -1;
        });
    }

    public toggle(): void {
        if (this._node.classList.contains('a-sign-languages-menu--show')) {
            this.hide();       
        } 
        else {
            this.show();
        }
    }

    public unload(): void {
    }

    public dispose(): void {
        this.hide();
        super.dispose();
    }
}